import { CommonError } from '@common/models/error.model';
import mainStore from '@input-web/modules/main/stores/main.store';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PropsWithChildren, useState } from 'react';

export default function ProviderApp({ children }: PropsWithChildren) {
  // #region Query Client
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
              if (
                error instanceof CommonError &&
                error.statusCode === 404 &&
                (error.message === 'Resource not found' ||
                  error.message === 'The specified blob does not exist.')
              ) {
                return false;
              }

              return failureCount < 3;
            },
          },
        },
        mutationCache: new MutationCache({ onError: (error) => mainStore.actions.addError(error) }),
        queryCache: new QueryCache({ onError: mainStore.actions.addError }),
      }),
  );
  // #endregion

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}
